import styled from 'styled-components';
import { device, minDevice } from '../../../Theme';

const AppName = styled.div`
    display: grid;
    grid-template-columns: 50px auto;
    align-items: center;
    justify-content: center;
    text-align: left;

    @media ${minDevice.tablet} {
        grid-template-columns: 60px auto;
    }
    @media ${device.mobileM} { 
        grid-template-columns: 100%;
        text-align: center;
        width: 100%;
    }
`;
const AppTitle = styled.div`
    font-size: 20px;
    font-weight: 500;
    margin: 0;
    padding: 0;
    margin-left: 10px;

    @media ${device.tablet} { 
        font-size: 20px;
    }    
    @media ${device.mobileM} { 
        margin-left: 0px;
        font-size: 18px;
    }
`;
const Image = styled.div`
    width: 50px;
    height: 50px;
    margin: 0;
    .img-container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    @media ${device.mobileM} { 
        margin: auto;
    }
    @media ${minDevice.tablet} { 
        width: 60px;
        height: 60px;
    }
`;
const Grid = styled.div`
    display: grid;
    justify-items: start;
    grid-template-columns: repeat(4, 1fr);
    grid-row-gap: 15px;
    grid-column-gap: 15px;

    @media ${device.laptop} { 
        grid-template-columns: repeat(3, 1fr);
    }
    @media ${device.tablet} { 
        grid-template-columns: repeat(2, 1fr);
    }
`;

export {
    Grid,
    Image,
    AppTitle,
    AppName
};